'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.currentBoardIdSet = undefined;

var _currentBoardIdConstants = require('./currentBoardIdConstants');

var currentBoardIdSet = exports.currentBoardIdSet = function currentBoardIdSet(_ref) {
    var boardId = _ref.boardId;
    return {
        type: _currentBoardIdConstants.CURRENT_BOARD_ID_SET,
        boardId: boardId
    };
}; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/currentBoardId/currentBoardIdActions.js
// module id = 750
// module chunks = 0